export const enum LOCALES {
  EN = 'en',
  UK = 'uk',
  RU = 'ru',
}

export const DEFAULT_LOCALE = LOCALES.UK;

export const AVAILABLE_LOCALES = [LOCALES.EN, LOCALES.RU, LOCALES.UK];
